import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class CsrfTokenStoreService {
  private csrfToken: string | null = null;
  private cookie: string | null = null;
  setToken(token: string) {
    this.csrfToken = token;
  }
  getToken(): string | null {
    return this.csrfToken;
  }
  getCookie(): string | null {
    return this.cookie;
  }
  setCookie(cookie: string) {
    this.cookie = cookie;
    const value = `${cookie}`;
    document.cookie = `${value}; path=/; domain=.bd.com; SameSite=Lax; Secure`;
  }
}
